export default __webpack_public_path__ + "static/2_23-006a0aa2e3c56b352935749e2e734d45.png";